//#region imports
import customAxios from '../../utils/customAxios';
import { formatDateDDMMYYYY } from '../../utils/dateFormat';
import React, { useState, useEffect } from 'react';

import { DataGridPro } from '@mui/x-data-grid-pro';

import ModalSDelete from '../Modal/Delete/ModalSDelete';
import ModalSActivate from '../Modal/Activate/ModalSActivate';
import { Tooltip } from '@mui/material';

import { Stack } from '@mui/system';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAdd,
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import { DeleteOutlineOutlined as DeleteIcon } from '@mui/icons-material';

import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';

import ModalSMultDelete from '../Modal/Delete/Multiple/ModalSMultDelete';
import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import ModalS from '../Modal/Create/ModalS';
import { GlobalVariables } from '../../globalVar';
import '../../scss/Elements/_tables.scss';
import ClientFilter from '../Utils/ClientFilter';
import ModalSUpdate from '../Modal/Update/ModalSUpdate';
import { useTableLocale } from '../../hooks/useTableLocale';
import { useUserPermissions } from '../../hooks/userPermissions';
import moment from 'moment-timezone';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
);

//#endregion

export const SitesTableAxios = () => {
  const userPermissions = useUserPermissions();
  // Config de hooks
  const [sitesData, setSitesData] = useState([]);
  const [selectedClients, setSelectedClients] = useState('all');
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [modalSitesShow, setModalSitesShow] = useState(false);
  const [modalSDeleteShow, setModalSDeleteShow] = useState(false);
  const [modalSActivateShow, setModalSActivateShow] = useState(false);
  const [modalSUpdateShow, setModalSUpdateShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [siteId, setSiteId] = useState(null);

  const { t } = useTranslation();

  const {
    sitesString,
    siteSiteNameString,
    sitePCString,
    siteStatusString,
    noSitesString,
    noSClientsSites,
    multDeleteString,
    addString,
    editString,
    deleteString,
    createdAtString,
    createdByString,
    updatedAtString,
    updatedByString,
    stateString,
    countryString,
    notesString,
  } = useTranslationHook();

  const locale = useTableLocale();

  useEffect(() => {
    const updateSiteData = () => {
      setSitesData((prevData) => {
        return prevData.map((site) => ({
          ...site,
          is_active: t(`${site.is_active}`),
        }));
      });
    };
    i18next.on('languageChanged', updateSiteData);

    return () => {
      i18next.off('languageChanged', updateSiteData);
    };
  }, [t]);

  useEffect(() => {
    let endpoint = `${GlobalVariables.getURL()}listClientSites?id=${selectedClients}`;

    getData(endpoint);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClients]);

  const getData = async (endpoint) => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      if (response.status === 204) {
        setSitesData([]);
      } else {
        const sitesData = response.data.sites.map((site) => {
          return {
            ...site,
            is_active: t(`${site.is_active}`),
          };
        });
        setSitesData(sitesData);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // No necesitas hacer nada en este efecto.
  }, [isLoading]);

  function manageSiteDelete(siteInfo) {
    var siteId = siteInfo.id;
    localStorage.setItem('siteIdToDelete', siteId);

    var siteName = siteInfo.site_name;
    var siteAddressStreet = siteInfo.address_street;
    var siteAddressNumber = siteInfo.address_number;
    var siteAddressPostalCode = siteInfo.address_postal_code;
    var siteBusinessName = siteInfo.business_name;
    var siteCreatedDate = siteInfo.created_at;

    localStorage.setItem('siteNameToDelete', siteName);
    localStorage.setItem('siteAddressStreetToDelete', siteAddressStreet);
    localStorage.setItem('siteAddressNumToDelete', siteAddressNumber);
    localStorage.setItem('siteAddressPCToDelete', siteAddressPostalCode);
    localStorage.setItem('siteBusinessToDelete', siteBusinessName);
    localStorage.setItem('siteCreatedDateToDelete', siteCreatedDate);
  }

  const [modalSMultipleDeleteShow, setModalSMultipleDeleteShow] =
    useState(false);

  function manageSiteMultipleDelete() {
    localStorage.setItem('sitesMultipleDeleteList', rowSelectionModel);
  }

  const dateSortComparator = (a, b) => {
    if (!a && !b) return 0;
    if (!a) return -1;
    if (!b) return 1;
    return a.getTime() - b.getTime();
  };

  const actionColumn = [
    {
      filterable: false,
      field: 'action',
      headerName: 'Acciones',
      headerClassNe: 'visits-datagrid-actions-tour',
      width: 180,
      pinnable: false, // Evita que el usuario la desancle
      disableColumnMenu: true,
      renderCell: (params) => {
        const isInactive = params.row.is_active === 'Inactivo';

        return (
          <div
            className="cellAction visits-datagrid-actions-tour"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
            }}
          >
            {/* ✏️ Editar */}
            {userPermissions.includes('Update Sites') && (
              <Tooltip title={editString} arrow>
                <button
                  type="button"
                  style={{ background: 'none', border: 'none', padding: 0 }}
                  onClick={() => {
                    setSiteId(params.row.id);
                    setModalSUpdateShow(true);
                  }}
                >
                  <ModeEditOutlineOutlinedIcon
                    className="detail-icons"
                    id="update-icon"
                  />
                </button>
              </Tooltip>
            )}

            {/* 🔁 Activar / Inactivar */}
            {userPermissions.includes(isInactive ? 'Update Sites' : 'Delete Sites') && (
              <Tooltip
                title={isInactive ? 'Activar sitio' : 'Inactivar sitio'}
                arrow
              >
                <button
                  type="button"
                  style={{ background: 'none', border: 'none', padding: 0 }}
                  onClick={() => {
                    if (isInactive) {
                      // 🟢 Guardar info para activar
                      localStorage.setItem('siteIdToActivate', params.row.id);
                      localStorage.setItem(
                        'siteNameToActivate',
                        params.row.site_name,
                      );
                      localStorage.setItem(
                        'siteAddressStreetToActivate',
                        params.row.address_street,
                      );
                      localStorage.setItem(
                        'siteAddressNumToActivate',
                        params.row.address_number,
                      );
                      localStorage.setItem(
                        'siteAddressPCToActivate',
                        params.row.postal_code,
                      );
                      localStorage.setItem(
                        'siteBusinessToActivate',
                        params.row.business_name,
                      );
                      localStorage.setItem(
                        'siteCreatedDateToActivate',
                        params.row.created_at,
                      );
                      setModalSActivateShow(true);
                    } else {
                      // 🔴 Guardar info para inactivar (usa el modal existente)
                      manageSiteDelete(params.row);
                      setModalSDeleteShow(true);
                    }
                  }}
                >
                  {isInactive ? (
                    <CheckCircleOutlineIcon
                      className="detail-icons"
                      id="activate-icon"
                      style={{ color: 'green' }}
                    />
                  ) : (
                    <BlockIcon
                      className="detail-icons"
                      id="deactivate-icon"
                      style={{ color: 'red' }}
                    />
                  )}
                </button>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  // Columnas
  const sitesColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
    },
    {
      field: 'region_name',
      headerName: 'Región',
      width: 150,
    },
    {
      field: 'business_name',
      headerName: 'Plaza',
      width: 180,
    },
    {
      field: 'is_active',
      headerName: siteStatusString,
      width: 110,
      renderCell: (params) => {
        if (
          params.row.is_active === 'Activo' ||
          params.row.is_active === 'Active'
        ) {
          return (
            <div>
              <span className="statusActive">{params.row.is_active}</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="statusInactive">{params.row.is_active}</span>
            </div>
          );
        }
      },
      valueGetter: (params) => params.row.is_active,
    },
    {
      field: 'notes',
      headerName: 'Comentarios',
      width: 200,
    },
    {
      field: 'site_name',
      headerName: siteSiteNameString,
      width: 170,
    },
    {
      field: 'address',
      headerName: 'Dirección completa',
      width: 230,
    },
    {
      field: 'cr',
      headerName: 'CR',
      width: 150,
    },
    {
      field: 'client_ti',
      headerName: 'Contacto Sucursal',
      width: 200,
      filterable: false,
    },
    // {
    //   field: 'extra_client_ti',
    //   headerName: 'TI Adicional',
    //   width: 200,
    //   filterable: false,
    // },
    {
      field: 'assigned_to',
      headerName: 'Asignado a',
      width: 150,
    },
    {
      field: 'is_priority',
      headerName: '¿Es sucursal prioritaria?',
      align: 'center',
      width: 150,
      renderCell: (params) => {
        const priority = params.row.is_priority;
        return priority ? 'Sí' : 'No';
      },
    },
    {
      field: 'entry_date',
      headerName: 'Fecha de entrada',
      width: 180,
      type: 'date',
      sortable: true,
      filterable: true,
      valueGetter: ({ value }) => {
        if (!value) return null;
        const parsed = moment(value, 'DD/MM/YYYY', true);
        return parsed.isValid() ? parsed.toDate() : null;
      },
      sortComparator: dateSortComparator,
      renderCell: ({ row }) => row.entry_date || '-',
    },
    {
      field: 'equal_date',
      headerName: 'Fecha de iguala',
      width: 180,
      type: 'date',
      sortable: true,
      filterable: true,
      valueGetter: ({ value }) => {
        if (!value) return null;
        const parsed = moment(value, 'DD/MM/YYYY', true);
        return parsed.isValid() ? parsed.toDate() : null;
      },
      sortComparator: dateSortComparator,
      renderCell: ({ row }) => row.equal_date || '-',
    },
    {
      field: 'prev_date',
      headerName: 'Fecha de previa',
      width: 180,
      type: 'date',
      sortable: true,
      filterable: true,
      valueGetter: ({ value }) => {
        if (!value) return null;
        const parsed = moment(value, 'DD/MM/YYYY', true);
        return parsed.isValid() ? parsed.toDate() : null;
      },
      sortComparator: dateSortComparator,
      renderCell: ({ row }) => row.prev_date || '-',
    },
    {
      field: 'address_city_name',
      headerName: 'Ciudad',
      width: 180,
      filterable: false,
    },
    {
      field: 'kmnivel',
      headerName: 'KM Nivel',
      width: 130,
      filterable: false,
    },
    {
      field: 'kms',
      headerName: 'KMS',
      width: 130,
      filterable: false,
    },
    {
      field: 'km1',
      headerName: 'KM1',
      width: 130,
      filterable: false,
    },
    {
      field: 'latitude',
      headerName: 'Latitud',
      width: 130,
      filterable: false,
    },
    {
      field: 'longitude',
      headerName: 'Longitud',
      width: 130,
      filterable: false,
    },
    {
      field: 'created_at',
      headerName: createdAtString,
      width: 200,
    },
    {
      field: 'created_by',
      headerName: createdByString,
      width: 150,
    },
    {
      field: 'updated_at',
      headerName: updatedAtString,
      width: 200,
    },
    {
      field: 'updated_by',
      headerName: updatedByString,
      width: 150,
    },
    // Map through all columns and add default renderCell if not already defined
  ].map((col) =>
    col.renderCell
      ? col
      : {
          ...col,
          renderCell: (params) =>
            ['created_at', 'updated_at'].includes(col.field)
              ? formatDateDDMMYYYY(params.row[col.field])
              : params.row[col.field] || '-',
        },
  );

  // Check if user has any action permissions
  const hasActionPermissions =
    userPermissions.includes('Update Sites') ||
    userPermissions.includes('Delete Sites');

  return (
    <>
      <div className="datatable" style={{ padding: '0px 16px' }}>
        <div className="datatable-btns-container">
          <div className="dt-btn-main-container">
            {userPermissions.includes('Create Sites') && (
              <button
                className="add-button create-site-tour"
                onClick={() => setModalSitesShow(true)}
              >
                {addString} <FontAwesomeIcon icon={faAdd} />
              </button>
            )}
            {userPermissions.includes('Delete Sites') && (
              <button
                disabled={isButtonDisabled}
                onClick={() => {
                  setModalSMultipleDeleteShow(true);
                  manageSiteMultipleDelete();
                }}
                className="multiple-delete-btn"
              >
                {multDeleteString}
              </button>
            )}
          </div>
        </div>

        <ModalS
          show={modalSitesShow}
          onHide={() => setModalSitesShow(false)}
          getSites={getData}
          selectedClients={selectedClients}
        />

        <ModalSMultDelete
          show={modalSMultipleDeleteShow}
          onHide={() => setModalSMultipleDeleteShow(false)}
          getSites={getData}
          selectedClients={selectedClients}
        />

        <ModalSDelete
          show={modalSDeleteShow}
          onHide={() => setModalSDeleteShow(false)}
          getSites={getData}
          selectedClients={selectedClients}
        />

        <ModalSActivate
          show={modalSActivateShow}
          onHide={() => setModalSActivateShow(false)}
          getSites={getData}
          selectedClients={selectedClients}
        />

        <ModalSUpdate
          siteId={siteId}
          show={modalSUpdateShow}
          onHide={() => setModalSUpdateShow(false)}
          getSites={getData}
          selectedClients={selectedClients}
        />

        <DataGridPro
          localeText={locale.components.MuiDataGrid.defaultProps.localeText}
          pagination
          loading={isLoading}
          initialState={{
            sorting: {
              sortModel: [
                { field: 'business_name', sort: 'asc' },
                { field: 'site_name', sort: 'asc' },
              ],
            },
            columns: {
              columnVisibilityModel: {
                id: false,
                assigned_to: false,
              },
            },
          }}
          pinnedColumns={hasActionPermissions ? { right: ['action'] } : {}}
          rows={sitesData}
          columns={
            hasActionPermissions
              ? sitesColumns.concat(actionColumn)
              : sitesColumns
          }
          checkboxSelection
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setRowSelectionModel(newRowSelectionModel);
            setIsButtonDisabled(newRowSelectionModel.length === 0);
          }}
          rowSelectionModel={rowSelectionModel}
          slots={{
            noRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {selectedClients.length === 0 ? noSClientsSites : noSitesString}
              </Stack>
            ),
            toolbar: (props) => (
              <ClientFilter
                selectedClients={selectedClients}
                setSelectedClients={setSelectedClients}
                {...props}
              />
            ),
          }}
          slotProps={{
            toolbar: {
              csvOptions: { utf8WithBom: true },
            },
          }}
        />
      </div>
    </>
  );
};
